// Product imagery. Only some products ship with a photo in the prototype;
// the rest fall back to the hatched placeholder rendered by the cards.
import stdStone from '../assets/products/std-stone.jpg';
import slottedStone from '../assets/products/slotted-stone.jpg';
import solidStone from '../assets/products/solid-stone.jpg';
import compactStone from '../assets/products/compact-stone.jpg';
import mandrels from '../assets/products/mandrels.png';
import singlePass from '../assets/products/single-pass.jpg';
import gauge from '../assets/products/gauge.jpg';

import heroLogo from '../assets/logos/hero.svg';
import hondaLogo from '../assets/logos/honda.png';
import musashiLogo from '../assets/logos/musashi.png';
import tataLogo from '../assets/logos/tata.svg';
import escortsLogo from '../assets/logos/escorts.png';

export const PRODUCT_IMAGES = {
  'standard-honing-stone': stdStone,
  'slotted-stone': slottedStone,
  'solid-stone': solidStone,
  'compact-stone': compactStone,
  mandrels,
  'single-pass': singlePass,
  gauge,
};

export const CLIENT_LOGOS = [
  { src: heroLogo, alt: 'Hero' },
  { src: hondaLogo, alt: 'Honda' },
  { src: musashiLogo, alt: 'Musashi' },
  { src: tataLogo, alt: 'Tata' },
  { src: escortsLogo, alt: 'Escorts' },
];
